import axios from "axios";

export function apiGetUsers(queryParams) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/users" + (queryParams ? "?" + queryParams : ""))
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetUserByIdColidee(idColidee, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/users/" +
        idColidee +
        (queryParams ? "?" + queryParams : "")
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateUserByIdColidee(idColidee, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/users/" + idColidee, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteUserByIdColidee(idColidee) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/users/" + idColidee)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSanitizeUser(idColidee, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/users/" + idColidee + "/sanitizeUser", formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
